import * as React from 'react'
import type { SVGProps } from 'react'

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 243.94 196.91"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '4px',
        }}
      >
        <path d="M121.92,12.14c8.46-2.52,17.42-3.88,26.7-3.88,51.54,0,93.32,41.78,93.32,93.32s-41.78,93.32-93.32,93.32-91.22-39.71-93.24-89.47" />
        <path d="M70.57,32.3c-10.82,15.76-8.17,31.81,1.88,37.92,5.03,3.06,11.4,2.82,17.65-.04,10.46-4.78,17-15.41,17-26.91,0-3.08-.04-6.37-.14-9.31-.58-16.14,6.96-31.96,6.96-31.96,0,0-33.52,16-43.35,30.3Z" />
        <path d="M68.51,92.8c-1.8-6.25-2.33-12.37.37-19,6.3-15.49,12.97-23.53,23.49-37.21l.13-.17" />
        <path d="M42.48,39.01c13.36,6.04,18,17.62,13.83,25.62-2.08,4-6.36,6.38-11.6,6.98-8.76,1.02-17.28-3.36-21.84-10.9-1.22-2.02-2.51-4.2-3.6-6.16C13.23,43.73,2,36.34,2,36.34c0,0,28.35-2.82,40.48,2.66Z" />
        <path d="M29.72,50.42l.15.06c12.34,4.8,22.81,12.95,30.42,23.27,2.54,3.44,4.91,7.46,6.78,11.34" />
        <path d="M175.26,12.14c-6.49,2.24-15.45,7.75-21.94,9.99-5.11,1.76-11.07,4.54-12.09,10.52-.57,3.37.69,6.89.07,10.25-1.53,8.31-12.61,9.73-15.36,17.62-1.55,4.45.23,9.69,3.22,13.06s6.98,5.26,10.87,7.08c15.44,7.22,22.65,10.6,13.09,6.12,3.74,1.75,7.47,3.49,11.21,5.24,12.45,5.82,26.39,11.71,38.99,6.32,3.47-1.48,6.64-3.76,10.1-5.24,3.47-1.48,7.48-2.08,10.79-.18,2.1,1.21,3.69,3.71,4.06,6.3.56,3.89,3.44,7.2,7.32,7.85,2.52.42,3.63-.29,5.23-3.2" />
        <path d="M55.38,105.44c10.1-4.37,18.39-.86,29.16,1.38,4.88,1.01,9.77,2.03,14.65,3.04,8.39,1.74,17.88,4.3,21.68,11.97,5.63,11.37-5.32,24.91-2.42,37.26.89,3.8,3.05,7.17,4.72,10.7s2.88,7.58,1.74,11.32-4.17.67-9.04,5.09" />
        <path d="M173.98,142.87c-.98,1.45-2.68,2.21-4.01,3.34-3.86,3.3-3.99,9.69-1.06,13.83,2.93,4.14,8.19,6.17,13.27,6.27,5.07.1,10.03-1.47,14.76-3.3,3.39-1.32,6.91-2.92,8.98-5.91,2.67-3.86,2.27-8.98,1.76-13.64-1.16-10.69-6.39-23.66-19.21-24.41-4.73-.28-10.77,2.99-13.21,6.99-3.32,5.46,2.01,12-1.28,16.82Z" />
      </g>
    </svg>
  )
}

export default Icon
